import React from "react";
import ReactDOM from "react-dom";
import App from "./components/core/App";
import "./css/styles.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
